import dayjs from "dayjs";
import { useState, lazy, Suspense, useMemo, useRef, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { t } from "i18next";
import { useTheme } from "../../context/ThemeContext";
import {
  useFloating,
  useClick,
  useDismiss,
  useRole,
  useListNavigation,
  useInteractions,
  FloatingFocusManager,
  useTypeahead,
  offset,
  size,
  autoUpdate,
  FloatingPortal,
  safePolygon,
} from "@floating-ui/react";
import { useHoverLeave } from "./useHoverLeave";
import PrimaryButton from "components/Button/PrimaryButton";
import CancelButton from "components/Button/CancelButton";

const DatePicker = lazy(() => import("react-datepicker"));
const APIDateFormat = "YYYY-MM-DD";
//Date Filter Function
const FilterDate = (props) => {
  const {
    from = "date",
    lastDays = 7,
    additionalFilter,
    defaultLabel = "_All",
    setFilterType,
    setApi,
    onSelect,
    locale,
    onOpen,
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [openCalender, setOpenCalender] = useState(false);

  const { theme } = useTheme();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const cacheRef = useRef("");

  const options = useMemo(() => {
    let arr = [];
    if (
      !(
        props.from === "report" ||
        props.from === "insights" ||
        props?.from === "audit"
      )
    ) {
      arr.push({
        label: t("_All"),
        value: "All",
      });
    }

    arr.push({
      label: t("_Today"),
      value: "Today",
    });

    arr.push({
      label: t("_Yesterday"),
      value: "Yesterday",
    });

    arr.push({
      label: t("_Last_$_days", {
        day: lastDays,
      }),
      value: `Last ${lastDays} days`,
    });

    if (!additionalFilter) {
      arr.push({
        label: t("_This_Month"),
        value: "This Month",
      });

      arr.push({
        label: t("_Last_30_days"),
        value: "Last 30 Days",
      });
    }

    arr.push({
      label: t("_Custom"),
      value: "Custom",
    });
    return arr;
  }, [from, lastDays, additionalFilter]);

  useEffect(() => {
    let selected = menuIndex;
    if (menuIndex !== defaultLabel && menuIndex?.length > 15) {
      selected = "Custom";
    }

    const index = options.findIndex((user) => user.value === selected);
    setSelectedIndex(index);
  }, [isOpen, options]);

  const [menuIndex, setMenuIndex] = useState(defaultLabel);

  useEffect(() => {
    setStartDate(new Date());
    setEndDate(null);
    if (props.from === "report") {
      setMenuIndex(t("_Select_Date_Range"));
    } else if (props.from === "insights" || props?.from === "audit") {
      setMenuIndex("Today");
    } else {
      setMenuIndex("All");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reportType || undefined || props?.customDays]);

  // useEffect(() => {
  //   //set default to yesterday
  //   if (props.from === "report") setMenuIndex("Yesterday");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props.defaultDateSelection]);

  const styles = {
    Modalstyle: `modal rounded-2xl fade shadow-lg z-10 outline-none overflow-x-hidden overflow-y-auto`,
    ApplyButtonStyle:
      " text-sm font-semibold rounded-full px-3 py-2 text-white ",
    CloseButtonStyle:
      "inline-block px-4 py-3 border border-Dove-Gray rounded-full text-Dove-Gray font-semibold text-sm leading-tight uppercase  focus:outline-none focus:ring-0  transition duration-150 ease-in-out ml-1",
    ClearButtonStyle:
      "inline-block px-4 py-3  rounded-full  font-semibold text-sm ml-auto leading-tight uppercase  focus:outline-none focus:ring-0 transition duration-150 ease-in-out",
  };

  const handleDateFormat = (date) => {
    if (locale) {
      return dayjs(date).toDate().toLocaleString(locale);
    }
    return dayjs(date).format(APIDateFormat);
  };
  const dateFilter = (e) => {
    let startDate = new Date();
    setShowDateRange(false);
    if (e === "Last 30 Days") {
      let todayMinus30 = dayjs(startDate).subtract(29, "d");
      props.withTimeStamp
        ? props.setFilterStartDate(
            dayjs(todayMinus30).format("YYYY-MM-DD") + "T00:00:00.000Z"
          )
        : props.setFilterStartDate(handleDateFormat(todayMinus30));
      props.withTimeStamp
        ? props.setFilterEndDate(
            dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000Z"
          )
        : props.setFilterEndDate(handleDateFormat(startDate));
      if (props.refetch) props.refetch();
      if (props.from === "report" && props.setDates)
        props.setDates([
          dayjs(todayMinus30).format("YYYY-MM-DD") + "T00:00:00.000",
          dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000",
        ]);
    } else if (e === `Last ${props?.lastDays || "7"} days`) {
      let todayMinus7 = dayjs(startDate).subtract(
        props?.lastDays ? props?.lastDays - 1 : 6,
        "d"
      );
      props.withTimeStamp
        ? props.setFilterEndDate(
            dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000Z"
          )
        : props.setFilterEndDate(handleDateFormat(startDate));
      props.withTimeStamp
        ? props.setFilterStartDate(
            dayjs(todayMinus7).format("YYYY-MM-DD") + "T00:00:00.000Z"
          )
        : props.setFilterStartDate(handleDateFormat(todayMinus7));
      if (props.refetch) props.refetch();
      if (props.from === "report" && props.setDates)
        props.setDates([
          dayjs(todayMinus7).format("YYYY-MM-DD") + "T00:00:00.000",
          dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000",
        ]);
    } else if (e === "Today") {
      props.withTimeStamp
        ? props.setFilterStartDate(
            dayjs(startDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
          )
        : props.setFilterStartDate(handleDateFormat(startDate));
      props.withTimeStamp
        ? props.setFilterEndDate(
            dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000Z"
          )
        : props.setFilterEndDate(handleDateFormat(startDate));
      if (props.refetch) props.refetch();
      if (props.from === "report" && props.setDates)
        props.setDates([
          dayjs(startDate).format("YYYY-MM-DD") + "T00:00:00.000",
          dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000",
        ]);
    } else if (e === "Yesterday") {
      let yesterday = dayjs(startDate).subtract(1, "d");
      props.withTimeStamp
        ? props.setFilterStartDate(
            dayjs(yesterday).format("YYYY-MM-DD") + "T00:00:00.000Z"
          )
        : props.setFilterStartDate(handleDateFormat(yesterday));
      props.withTimeStamp
        ? props.setFilterEndDate(
            dayjs(yesterday).format("YYYY-MM-DD") + "T23:59:59.000Z"
          )
        : props.setFilterEndDate(handleDateFormat(yesterday));
      if (props.refetch) props.refetch();
      if (props.from === "report" && props.setDates)
        props.setDates([
          dayjs(yesterday).format("YYYY-MM-DD") + "T00:00:00.000",
          dayjs(yesterday).format("YYYY-MM-DD") + "T23:59:59.000",
        ]);
    } else if (e === "This Month") {
      let firstDateOfMonth = dayjs(startDate).startOf("M");
      props.withTimeStamp
        ? props.setFilterStartDate(
            dayjs(firstDateOfMonth).format("YYYY-MM-DD") + "T00:00:00.000Z"
          )
        : props.setFilterStartDate(handleDateFormat(firstDateOfMonth));
      props.withTimeStamp
        ? props.setFilterEndDate(
            dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000Z"
          )
        : props.setFilterEndDate(handleDateFormat(startDate));
      if (props.refetch) props.refetch();
      if (props.from === "report" && props.setDates)
        props.setDates([
          dayjs(firstDateOfMonth).format("YYYY-MM-DD") + "T00:00:00.000",
          dayjs(startDate).format("YYYY-MM-DD") + "T23:59:59.000",
        ]);
    } else if (e === "All") {
      props.setFilterEndDate("");
      props.setFilterStartDate("");
      if (props.refetch) props.refetch();
    } else if (e === "Custom") {
      setOpenCalender(true);
      if (props.from === "report" && props.setDates) props.setDates(["", ""]);
    }
  };
  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const filterCustom = (e) => {
    if (e === "Apply") {
      setMenuIndex(
        dayjs(startDate).format(theme.dateFormat) +
          "-" +
          dayjs(endDate).format(theme.dateFormat)
      );

      if (props.setDates) props.setDates([startDate, endDate, "custom"]);

      props.withTimeStamp
        ? props.setFilterStartDate(
            dayjs(startDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
          )
        : props.setFilterStartDate(handleDateFormat(startDate));
      props.withTimeStamp
        ? props.setFilterEndDate(
            dayjs(endDate).format("YYYY-MM-DD") + "T23:59:59.000Z"
          )
        : props.setFilterEndDate(handleDateFormat(endDate));
      if (props.refetch) props.refetch();
      setShowDateRange(true);
    } else if (e === "Cancel") {
      //props.setFilterStartDate("");
      //props.setFilterEndDate("");
      //setStartDate(new Date());
      //setEndDate(new Date());
      if (props.refetch) props.refetch();
    } else if (e === "Clear") {
      setStartDate(undefined);
      setEndDate(undefined);
      props.setFilterStartDate("");
      props.setFilterEndDate("");
    }
    if (setFilterType) {
      setFilterType(e === "Apply" ? "CUSTOM" : "All");
      if (e === "Clear") {
        cacheRef.current = "_All";
        setMenuIndex(cacheRef.current);
      }
    }
    if (setApi) {
      if (e === "All" || e === "Clear") {
        setApi("getAllRoles");
      } else {
        setApi("datefilter");
      }
    }
    if (onSelect) {
      onSelect(e);
    }
  };

  const { refs, floatingStyles, context } = useFloating({
    placement: from === "insights" ? "bottom-end" : "bottom-start",
    open: isOpen,
    onOpenChange: (open) => {
      setIsOpen(open);
      if (onOpen) {
        onOpen(open);
      }
      if (open === false && menuIndex === "Custom") {
        setMenuIndex(cacheRef.current);
        setOpenCalender(false);
      } else {
        cacheRef.current = menuIndex;
      }
    },
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(8),
      size({
        apply({ rects, elements, availableHeight }) {
          Object.assign(elements.floating.style, {
            maxHeight: `${availableHeight}px`,
            minWidth: `${rects.reference.width}px`,
          });
        },
        padding: 10,
      }),
    ],
  });

  const listRef = useRef([]);
  const listContentRef = useRef(options.map((item) => item.label));
  const isTypingRef = useRef(false);

  const click = useClick(context, { event: "mousedown" });
  const dismiss = useDismiss(context);
  const role = useRole(context, { role: "listbox" });
  const listNav = useListNavigation(context, {
    listRef,
    activeIndex,
    selectedIndex,
    onNavigate: setActiveIndex,
    // This is a large list, allow looping.
    loop: true,
  });
  const typeahead = useTypeahead(context, {
    listRef: listContentRef,
    activeIndex,
    selectedIndex,
    onMatch: isOpen ? setActiveIndex : setSelectedIndex,
    onTypingChange(isTyping) {
      isTypingRef.current = isTyping;
    },
  });

  let hoverLeave = null;
  if (props.from !== "report") {
    hoverLeave = useHoverLeave(context, {
      enabled: true, // only enable hover interactions once open
      handleClose: safePolygon(),
    });
  }

  const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions(
    [dismiss, role, listNav, typeahead, click, hoverLeave]
  );

  const selectedItemLabel =
    selectedIndex !== null ? options[selectedIndex] : undefined;

  const handleSelect = (id) => {
    if (id) {
      setMenuIndex(id);
      dateFilter(id);
      if (id !== "Custom") setIsOpen(false);

      if (setFilterType) {
        setFilterType(id === "All" ? "All" : "CUSTOM");
      }
      if (setApi) {
        setApi(id === "All" || id === "Clear" ? "getAllRoles" : "datefilter");
      }
      if (onSelect) {
        onSelect(id);
      }
    }
  };

  return (
    <div>
      {from === "date" && (
        <button
          type="button"
          className={`text-sm font-semibold overflow-hidden rounded-md my-auto px-3 py-2.5 bg-white focus:outline-none focus:ring-0 border select-none appearance-none ${
            isOpen
              ? "border-primaryColor text-primaryColor"
              : "border-LightGrayxs text-Dark-Grey"
          }`}
          style={
            isOpen
              ? { borderColor: theme.primaryColor, color: theme.primaryColor }
              : {}
          }
          id="menu-button"
          tabIndex={0}
          ref={refs.setReference}
          aria-expanded="true"
          aria-labelledby="select-label"
          aria-haspopup="true"
          aria-autocomplete="none"
          {...getReferenceProps()}
        >
          <div className="flex items-center justify-center">
            {t(menuIndex)}
            <svg
              className={`h-5 w-5 ltr:ml-0 rtl:mr-0`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </button>
      )}

      {from === "insights" && (
        <button
          type="button"
          className={`text-sm font-semibold overflow-hidden rounded-md my-auto px-3 py-2 bg-[#FAFAFA] focus:outline-none focus:ring-0 border border-LightGrayxs select-none appearance-none`}
          id="menu-button"
          tabIndex={0}
          ref={refs.setReference}
          aria-expanded="true"
          aria-labelledby="select-label"
          aria-haspopup="true"
          aria-autocomplete="none"
          {...getReferenceProps()}
        >
          <div className="flex items-center justify-center text-gray-700">
            {t(menuIndex)}
            <svg
              className={`h-5 w-5 ltr:ml-0 rtl:mr-0`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </button>
      )}

      {from === "report" && (
        <button
          type="button"
          className={`${props.className} select-none appearance-none ${
            isOpen ? "border-primaryColor" : "border-gray-300"
          }`}
          style={
            isOpen
              ? {
                  borderColor: "#353ef2",
                  boxShadow: "0 0 2px #353ef2",
                }
              : {}
          }
          id="menu-button"
          tabIndex={0}
          ref={refs.setReference}
          aria-expanded="true"
          aria-labelledby="select-label"
          aria-haspopup="true"
          aria-autocomplete="none"
          {...getReferenceProps()}
        >
          <div className={`flex items-center`}>
            <span
              className={`overflow-hidden whitespace-nowrap text-ellipsis overflow-ellipsis ${
                menuIndex?.length > 15 ? "text-sm" : ""
              }`}
              style={{
                flex: "1 1 0%",
                color:
                  menuIndex === t("_Select_Date_Range")
                    ? "#CACACA"
                    : "hsl(0, 0%, 20%)",
              }}
            >
              {t(menuIndex)}
            </span>

            <div
              style={{
                alignItems: "center",
                alignSelf: "stretch",
                display: "flex",
                flexShrink: 0,
                borderSizing: "border-box",
              }}
            >
              <div
                style={{
                  display: "flex",
                  transition: "color 150ms",
                  color: "hsl(0, 0%, 80%)",
                  padding: "8px",
                  boxSizing: "border-box",
                }}
                aria-hidden="true"
              >
                <svg
                  height="20"
                  width="20"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                  focusable="false"
                  style={{
                    display: "inline-block",
                    fill: "currentColor",
                    lineHeight: 1,
                    stroke: "currentcolor",
                    strokeWidth: 0,
                  }}
                >
                  <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                </svg>
              </div>
            </div>
          </div>
        </button>
      )}
      {isOpen && (
        <FloatingPortal>
          <FloatingFocusManager context={context} modal={false}>
            <div
              ref={refs.setFloating}
              className={`z-[99] overflow-y-auto border border-rounded border-Silver min-w-32 text-center bg-white focus:outline-none ${
                props.from == "report"
                  ? ""
                  : "shadow-lg ring-1 ring-black ring-opacity-5"
              }`}
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex="-1"
              style={{
                ...floatingStyles,
                // ...(props.from === "report"
                //   ? { paddingBottom: "4px", paddingTop: "4px" }
                //   : {}),
                borderRadius: props.from === "report" ? "4px" : "0.375rem",
              }}
              {...getFloatingProps()}
            >
              {openCalender ? (
                <div
                  className="flex flex-col bg-white"
                  style={{
                    minHeight: "24rem",
                    minWidth: "30rem",
                  }}
                >
                  <div
                    className="m-4 border-b flex pb-4 border-gray-600 text-sm font-medium justify-between"
                    onClick={() => {
                      setOpenCalender(false);
                    }}
                  >
                    <p>{t("_Date_Range")}</p>
                    <button>
                      <i className="fa fa-close" />
                    </button>
                  </div>
                  <Suspense fallback={t("_Loading...")}>
                    <DatePicker
                      open={openCalender}
                      isOutsideRange={() => false}
                      startDate={startDate}
                      selected={startDate}
                      endDate={endDate}
                      minDate={
                        props?.customDays
                          ? new Date(
                              new Date().setDate(
                                new Date().getDate() - props?.customDays + 1
                              )
                            )
                          : null
                      }
                      maxDate={new Date()}
                      // focusSelectedMonth={false}
                      // showPreviousMonths
                      monthsShown={2}
                      selectsRange
                      inline
                      disabledKeyboardNavigation={true}
                      style={{
                        "background-color": "white",
                        display: "inline-flex",
                      }}
                      onChange={(e) => {
                        onChange(e);
                      }}
                    />
                  </Suspense>
                  <div className="modal-footer flex flex-shrink-0 flex-wrap justify-end py-3 pr-2 border-t border-gray-200 rounded-b-md gap-2">
                    <PrimaryButton
                      type="button"
                      className="py-0 font-normal"
                      style={{ minWidth: 20, height: "28px" }}
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setOpenCalender(false);
                        filterCustom("Apply");
                        setIsOpen(false);
                      }}
                      disabled={!startDate || !endDate}
                    >
                      {t("_Apply")}
                    </PrimaryButton>
                    {/* <button
                      className={styles.CloseButtonStyle}
                      onClick={() => {
                        setOpenCalender(false);
                        setIsOpen(false);
                        if (startDate && endDate)
                          setMenuIndex(
                            dayjs(startDate).format(theme.dateFormat) +
                              "-" +
                              dayjs(endDate).format(theme.dateFormat)
                          );
                        filterCustom("Cancel");
                      }}
                    >
                      {t("_CANCEL")}
                    </button> */}
                    <CancelButton
                      type="button"
                      data-bs-dismiss="modal"
                      className="py-0 font-normal"
                      style={{ minWidth: 20, height: "28px" }}
                      onClick={() => {
                        filterCustom("Clear");
                      }}
                    >
                      {t("_Clear")}
                    </CancelButton>
                  </div>
                </div>
              ) : (
                <div role="group">
                  {options.map((item, i) => (
                    <div
                      className={`text-gray-700 block text-left cursor-pointer ${
                        props.from == "report"
                          ? "text-[14px]"
                          : "font-semibold text-sm"
                      }`}
                      ref={(node) => {
                        listRef.current[i] = node;
                      }}
                      style={{
                        padding: "8px 12px",
                        background:
                          i === activeIndex
                            ? "#F3F3F3"
                            : selectedIndex === i
                            ? "#ebebeb"
                            : "#ffffff",
                      }}
                      role="menuitem"
                      tabIndex={i === activeIndex ? 0 : -1}
                      aria-selected={i === selectedIndex && i === activeIndex}
                      id={item.value}
                      key={item.value}
                      {...getItemProps({
                        // Handle pointer select.
                        onClick(e) {
                          handleSelect(item.value);
                        },
                        // Handle keyboard select.
                        onKeyDown(event) {
                          console.log("event", event);
                          if (event.key === "Enter") {
                            event.preventDefault();
                            setSelectedIndex(i);
                            handleSelect(item.value);
                          }

                          if (event.key === " " && !isTypingRef.current) {
                            event.preventDefault();
                            setSelectedIndex(i);
                          }
                        },
                      })}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </FloatingFocusManager>
        </FloatingPortal>
      )}
    </div>
  );
};
export default FilterDate;
